class RoomService {
    parseRoomConfigValues(room) {
        const extendedRoom = Object.assign({}, room);
        if (extendedRoom && extendedRoom.roomConfigurations) {
            extendedRoom.roomConfigurations.forEach(rc => {
                if (typeof rc.value === 'string') rc.value = JSON.parse(rc.value);
            });
        }
        return extendedRoom;
    }
}
export default new RoomService();



// WEBPACK FOOTER //
// ./src/services/room.service.js